import { render, staticRenderFns } from "./RecordFeeList.vue?vue&type=template&id=8b08fa2a"
import script from "./RecordFeeList.vue?vue&type=script&lang=js"
export * from "./RecordFeeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports